<template>
    <div>
        <HeaderStock header="ตั้งค่าข้อมูลเกี่ยวกับคลัง" :img_header="header_image" link_back="stock" />
        <MenuStockSetting/>
        <StockTypeList/>
    </div>
</template>

<script>
import HeaderImage from '@/assets/icon-stock-setting.png'
import HeaderStock from '@/components/menuadmin/stock/stockheader/HeaderStock.vue'
import MenuStockSetting from '@/components/menuadmin/stock/stocksetting/MenuStockSetting.vue'
import StockTypeList from '@/components/menuadmin/stock/stocksetting/StockTypeList.vue'
export default {
    name:'stockType',
    components:{
        HeaderStock,
        MenuStockSetting,
        StockTypeList,
    },
    data(){
        return{
            header_image:HeaderImage
        }
    }
}
</script>